import React from 'react';
import cssClass from './PredefinedModuleSection.module.css';

const PredefinedModuleSection = () => {
  return (
    <div className={cssClass['component-container']}>
      <div className={cssClass['coming-soon']}>
        <p>Coming Soon</p>
      </div>
    </div>
  );
};

export default PredefinedModuleSection;
